"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HeaderLink = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18nify = require("react-i18nify");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var HeaderLink = /*#__PURE__*/function (_React$Component) {
  _inherits(HeaderLink, _React$Component);

  function HeaderLink() {
    _classCallCheck(this, HeaderLink);

    return _possibleConstructorReturn(this, _getPrototypeOf(HeaderLink).apply(this, arguments));
  }

  _createClass(HeaderLink, [{
    key: "render",
    value: function render() {
      var targetText = null;
      var relText = null;
      var srText = "";
      var onClickHandler = null;

      if (this.props.inNewWindow) {
        targetText = "_blank";
        relText = "noopener noreferrer";
        srText = _react["default"].createElement("span", {
          className: "sr-only"
        }, _react["default"].createElement(_reactI18nify.Translate, {
          value: "header.newWindow"
        }));
      }

      if (this.props.onClick) {
        onClickHandler = this.props.onClick;
      }

      return _react["default"].createElement("span", {
        className: "header-link d-none d-xl-inline"
      }, _react["default"].createElement("a", {
        href: this.props.href,
        onClick: onClickHandler,
        target: targetText,
        rel: relText,
        alt: this.props.alt,
        className: "small text-dark focus-outline-primary hover-color-primary text-decoration-none px-1 d-inline-block"
      }, this.props.children, srText), _react["default"].createElement("span", {
        className: "vertical-separator mx-3"
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        "alt": _propTypes["default"].string,
        "children": _propTypes["default"].object,
        "href": _propTypes["default"].string,
        "inNewWindow": _propTypes["default"].bool,
        "onClick": _propTypes["default"].func
      };
    }
  }]);

  return HeaderLink;
}(_react["default"].Component);

exports.HeaderLink = HeaderLink;
var _default = HeaderLink;
exports["default"] = _default;